import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Hero from '../../components/Service/CoursesDailyConversation/Hero';
import Overview from '../../components/Service/CoursesDailyConversation/Overview';
import Outcome from '../../components/Service/CoursesDailyConversation/Outcome';
import About from '../../components/organisms/CoursesAbout';
import Testimonials from '../../components/organisms/Testimonials';
import StartNow from '../../components/organisms/StartNow';

const DailyConversation = (_props) => {
  const { t } = useTranslation('common');
  return (
    <div>
      <Head>
        <title>{t('title.courses.dailyConversation')}</title>
        <meta
          name="description"
          content={t('description.courses.dailyConversation')}
        />
      </Head>
      <div className="breadCrumb" />
      <Hero />
      <Overview />
      <Outcome />
      <About />
      <Testimonials />
      <StartNow />
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default DailyConversation;
